import { SubmitSurveyRequestSchema, SubmitSurveyResponseSchema } from './submit-survey.schema';
/**
 * Submit Survey Endpoint Contract
 * Submits or updates a survey with user responses
 */ export const submitSurveyContract = {
    method: 'POST',
    path: '/api/v2/survey/:id/submit',
    description: 'Submit or update a survey with user responses',
    requestSchema: SubmitSurveyRequestSchema,
    responseSchema: SubmitSurveyResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid survey data',
            401: 'Unauthorized - user not authenticated',
            404: 'Survey not found'
        }
    }
};

//# sourceMappingURL=submit-survey.contract.js.map